<template>
    <div class="home_wrap">
        <!-- 右边弹框 -->
        <van-popup v-model="show" position="right">
            <div class="main-box">
                <div class="personal-data-page" v-if="showInfoStatus">
                    <!-- 顶部导航 -->
                    <div class="title-box">
                        <button class="back" @click="showInfoStatus = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2>{{ $t('Personal') }}</h2>
                        <button class="btn" @click="show = false">
                            <i class="iconfont icon-guanbi"></i>
                        </button>
                    </div>
                    <!-- 信息卡片 -->
                    <div class="info-card">
                        <div class="card-header">
                            <h2 class="card-title">{{ $t('Yourinformation') }}</h2>
                            <p class="card-subtitle">{{ $t('youraccount') }}</p>
                        </div>
                        <div class="divider"></div>

                        <div class="info-row">
                            <span class="info-label">{{ $t('xingming') }}</span>
                            <span class="info-value">{{ userInfo.name }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">{{ $t('email') }}</span>
                            <span class="info-value">{{ userInfo.email || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">{{ $t('sj') }}</span>
                            <span class="info-value">{{ userInfo.mobile || '—' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">ID</span>
                            <span class="info-value">{{ userInfo.uid }}</span>
                        </div>

                        <div class="divider"></div>

                        <div class="info-row">
                            <span class="info-label">{{ $t('Level') }}</span>
                            <span class="info-value">{{ $t('Level') }}.{{ userInfo.level.level }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">{{ $t('Referralcode') }}</span>
                            <span class="info-value">{{ invite_code || '—' }}</span>
                        </div>
                        <!-- <div class="info-row">
                            <span class="info-label">{{ $t('CreatedTime') }}</span>
                            <span class="info-value">{{ userInfo.createdAt }}</span>
                        </div> -->
                    </div>
                    <div class="hr"></div>
                    <div class="t-box" style="height: 50px;position: relative;cursor: pointer;" @click="logout">
                        <i class="iconfont icon-a-tuichuyichu" style="color: #FDE68A;font-size:18px;"></i>
                        <div class="t1"
                            style="position: absolute;left: 50%; top:50%; transform: translate(-50%,-50%);color: #ffffff;font-size: 14px;font-weight: bold;">
                            {{ $t('LogOut') }}
                        </div>
                    </div>
                    <div style="height: 50px;"></div>
                </div>
                <div class="pop_pass" v-if="showChangePass">
                    <div class="pop-pass-box" @click.stop>
                        <div class="hrs"></div>
                        <div class="title-box">
                            <h2>{{ $t('safe.signInPassword') }}</h2>
                            <button class="btn" @click="showChangePass = false">
                                <i class="iconfont icon-guanbi"></i>
                            </button>
                        </div>
                        <!-- <div class="form-group">
                            <label class="form-label">{{ $t('Currentpassword') }}</label>
                            <input type="password" class="form-input" v-model="currentPassword"
                                placeholder="Enter current password">
                        </div> -->

                        <div class="form-group">
                            <label class="form-label">{{ $t('Newpassword') }}</label>
                            <input type="password" class="form-input" v-model="newPassword"
                                :placeholder="$t('setpwd.newpassword')">
                        </div>

                        <div class="form-group">
                            <label class="form-label">{{ $t('ConfirmPass') }}</label>
                            <input type="password" class="form-input" v-model="confirmPassword"
                                :placeholder="$t('setpwd.confirmnewpassword')">
                        </div>

                        <button class="save-btn" @click="handleSavePassword">
                            <svg width="20" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            {{ $t('Savepass') }}
                        </button>
                    </div>
                </div>
                <div class="pop_pass" v-if="showChangePayPass">
                    <div class="pop-pass-box" @click.stop>
                        <div class="hrs"></div>
                        <div class="title-box">
                            <h2>{{ $t('safe.paymentPassword') }}</h2>
                            <button class="btn" @click="showChangePayPass = false">
                                <i class="iconfont icon-guanbi"></i>
                            </button>
                        </div>
                        <!-- <div class="form-group">
                            <label class="form-label">{{ $t('Currentpassword') }}</label>
                            <input type="password" class="form-input" v-model="currentPassword"
                                placeholder="Enter current password">
                        </div> -->

                        <div class="form-group">
                            <label class="form-label">{{ $t('Newpassword') }}</label>
                            <input type="password" class="form-input" v-model="newPayPassword"
                                :placeholder="$t('setpwd.newpassword')">
                        </div>

                        <div class="form-group">
                            <label class="form-label">{{ $t('ConfirmPass') }}</label>
                            <input type="password" class="form-input" v-model="confirmPayPassword"
                                :placeholder="$t('setpwd.confirmnewpassword')">
                        </div>

                        <button class="save-btn" @click="handleSavePayPassword">
                            <svg width="20" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg>
                            {{ $t('Savepass') }}
                        </button>
                    </div>
                </div>
                <div class="box">
                    <div class="title-box">
                        <h2>{{ $t('Settings') }}</h2>
                        <button type="button" class="btn" @click="show = false">
                            <i class="iconfont icon-guanbi"></i>
                        </button>
                    </div>
                    <div class="uls">
                        <div class="t">
                            <h3>{{ $t('Profile') }}</h3>
                        </div>
                        <div class="t-box" @click="showInfoStatus = true">
                            <div class="logo">
                                <i class="iconfont icon-geren"></i>
                            </div>
                            <div class="t-boxs">
                                <div class="t1">
                                    {{ $t('Personal') }}
                                </div>
                                <div class="t2">
                                    {{ userInfo !== null ? userInfo.name : '' }}
                                </div>
                            </div>
                            <div class="icon">
                                <i class="iconfont icon-youjiantou"></i>
                            </div>
                        </div>
                        <div class="t-box" @click="showChangePass = true">
                            <div class="logo">
                                <i class="iconfont icon-yuechi1"></i>
                            </div>
                            <div class="t-boxs">
                                <div class="t1">
                                    {{ $t('setpwd.setNewLoginPassword') }}
                                </div>
                                <div class="t2">
                                    {{ $t('Keep') }}
                                </div>
                            </div>
                            <div class="icon">
                                <i class="iconfont icon-youjiantou"></i>
                            </div>
                        </div>
                        <div class="t-box" @click="showChangePayPass = true">
                            <div class="logo">
                                <i class="iconfont icon-yuechi1"></i>
                            </div>
                            <div class="t-boxs">
                                <div class="t1">
                                    {{ $t('setpaypwd.setNewPaymentPassword') }}
                                </div>
                                <div class="t2">
                                    {{ $t('Keep') }}
                                </div>
                            </div>
                            <div class="icon">
                                <i class="iconfont icon-youjiantou"></i>
                            </div>
                        </div>
                        <div class="t-box" @click="$router.push('/account')">
                            <div class="logo">
                                <i class="iconfont icon-yinhangka"></i>
                            </div>
                            <div class="t-boxs">
                                <div class="t1">
                                    {{ $t('user.myWallet') }}
                                </div>
                            </div>
                            <div class="icon">
                                <i class="iconfont icon-youjiantou"></i>
                            </div>
                        </div>
                        <div class="t" style="margin-top: 20px;">
                            <h3>{{ $t('yuyan') }}</h3>
                        </div>
                        <div class="t-box">
                            <div class="li" @click.stop="showLangStatus = !showLangStatus">
                                <div class="logos">
                                    <img :src="require(`../../assets/images/langLogo/${lang}.png`)" alt="">
                                </div>
                                <div class="t-text">
                                    {{ lang_list[lang] }}
                                </div>
                                <div class="icon" :class="{ 'xz': showLangStatus }">
                                    <i class="iconfont icon-xiajiantou"></i>
                                </div>
                            </div>
                            <div class="boxs" v-if="showLangStatus">
                                <a class="lis" :class="{ 'active-li': lang }" v-for="(item, key) in lang_list"
                                    :key="key" @click="changeLang(key)">
                                    <img :src="require(`../../assets/images/langLogo/${key}.png`)" alt="">
                                    <span>{{ item }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="hr"></div>
                        <div class="t-box" style="height: 50px;position: relative;;cursor: pointer;" @click="logout">
                            <i class="iconfont icon-a-tuichuyichu" style="color: #FDE68A;font-size:18px;"></i>
                            <div class="t1"
                                style="position: absolute;left: 50%; top:50%; transform: translate(-50%,-50%);color: #ffffff;font-size: 14px;font-weight: bold;">
                                {{ $t('LogOut') }}
                            </div>
                        </div>
                        <div style="height: 50px;"></div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 底部弹框 -->
        <van-popup v-model="orderShow" position="bottom">
            <div class="deposit-modal" v-if="infos !== null">
                <!-- 顶部标题栏 -->
                <div class="hrs"></div>
                <div class="modal-header">
                    <div class="user-info">
                        <div class="user-name">{{ infos.title }} - {{ infos.day_date_num_text }}</div>
                        <div class="profit-info">{{ $t('Totalprofit') }}:
                            +{{ Number(infos.interest_rate.current_annual_rate) }}% · {{ $t('Annual') }}:
                            +{{ Number(infos.interest_rate.today_profit_rate) }}%</div>
                    </div>
                    <button class="deposit-btn" @click="$router.push('/deposit')">{{ $t('moneybag.recharge')
                        }}</button>
                </div>

                <!-- 可用余额 -->
                <div class="info-card">
                    <div class="card-label">{{ $t('AVAILABLEBALANCE') }}</div>
                    <div class="card-value">{{ userInfo.money }} {{ $cut2 }}</div>
                </div>

                <!-- 投资金额 -->
                <div class="lis">
                    <div class="investment-label">{{ $t('utils.investmentAmount') }}</div>
                    <div class="rules-link">{{ $t('Rules') }}</div>
                </div>
                <div class="investment-row" style="flex-direction: column;align-items: flex-start;">

                    <div class="investment-right">
                        <input class="investment-value" v-model="amtValue" type="number"></input>
                        <div class="cut">{{ $cut2 }}</div>
                    </div>
                    <!-- <div style="margin-top: 4px;font-size: 10px;color: #CBCB41;">
                       {{ $t('Mininvest') }} {{ infos.min }} ~ {{$t('Maxinvest')}} {{ infos.max }}
                    </div> -->
                </div>
                <!-- 总计 -->
                <div class="total-row">
                    <!-- <div class="fee-row">
                        <div class="fee-label">{{ $t('Discount') }}</div>
                        <div class="fee-value">{{ $t('Nocoupon') }}</div>
                    </div> -->
                    <!-- <div class="fee-row">
                        <div class="fee-label">{{ $t('Handling') }}</div>
                        <div class="fee-value">{{ infos.fee_ratio }} {{ $cut2 }}</div>
                    </div> -->

                    <div class="total-inner">
                        <div class="total-label">{{ $t('Totaltopay') }}</div>
                        <div class="total-value">{{ amtValue }} {{ $cut2 }}</div>
                    </div>
                </div>

                <!-- 操作按钮 -->
                <div class="action-buttons">
                    <button class="ok-btn" @click="handleOk">{{ $t('utils.confirm') }}</button>
                    <button class="cancel-btn" @click="handleCancel">{{ $t('utils.cancel') }}</button>
                </div>
            </div>
        </van-popup>
        <!-- 兑换码 -->
         <div class="dhm-box" v-if="showDHM">
            <div class="box">
                <a class="off-btn" @click.stop="showDHM = false">
                    <i class="iconfont icon-guanbi"></i>
                </a>
                <img src="../../assets//images/ResgateSeuCupom.png" alt="">
                <div class="boxs" @click.stop>
                    <div class="title">
                        {{ $t('兑换码') }}
                    </div>
                    <div class="inputs">
                        <input type="text" v-model="duhText" :placeholder="$t('EnterTheCode')">
                    </div>
                    <div class="submit">
                        <button @click="submitDhm">
                            {{ $t('ValidateCoupon') }}
                        </button>
                    </div>
                </div>
            </div>
         </div>
        <div class="wallet-container">
            <div class="wallet-containers" v-if="userInfo != null">
                <!-- 顶部导航 -->
                <div class="top-nav">
                    <div class="nav-right">
                        <div class="vip-badge">
                            <i class="iconfont icon-dunpai"></i>
                            <span style="color: #ffffff">VIP</span>
                        </div>
                        <div class="chat-icon" style="border: none;" @click="showDhmFun">
                            <i class="iconfont icon-xiaofeiquan" style="font-size:24px;color:#DFD700;"></i>
                        </div>
                        <div class="chat-icon" @click="toUrl(2)"  v-if="whatsapp != ''">
<!--                            <i class="iconfont icon-zhifeiji" style="font-size:12px;"></i>-->
                            <img style="display: block;padding: 0px;width: 100%;height: 100%;" src="../../assets/images/t.png" alt="">
                        </div>
                        <div class="chat-icon" @click="toUrl(3)" v-if="telegram != ''">
<!--                            <i class="iconfont icon-zhifeiji" style="font-size:12px;"></i>-->
                            <img style="display: block;padding: 0px;width: 100%;height: 100%;" src="../../assets/images/t.png" alt="">
                        </div>
                        <div class="chat-icon" @click="toUrl(1)" style="border: none;" v-if="kefu_link != ''">
                            <i class="iconfont icon-tonghua"></i>
                        </div>
                        <a class="more-icon" @click="showFun">⋮</a>
                    </div>
                </div>

                <!-- 余额数据卡片 -->
                <div class="balance-grid">
                    <div class="balance-card">
                        <div class="balance-change"> {{ showYj ? userInfo.yesterday_money : '*****' }}
                            <span style="font-size: 12px;color:#e4e5e1;"> ≈{{ showYj ? $cut2 + userInfo.yesterday_money
                                : '*****' }}</span>
                        </div>
                        <div class="balance-label">{{ $t('Yesterday') }}</div>
                    </div>

                    <div class="balance-card">
                        <div class="balance-change" style="color:#e4e5e1;">{{ showYj ? userInfo.total_assets : '*****' }}
                            <a class="yj" @click.stop="showYj = !showYj">
                                <i class="iconfont" :class="{ 'icon-yanjing': showYj, 'icon-biyan': !showYj }"></i>
                            </a>
                        </div>
                        <div class="balance-label">{{ $t('TotalBalance') }}</div>
                    </div>

                    <div class="balance-card total-balance-card">
                        <a class="expand-icon" @click.stop="showBalanceFun">
                            <i class="iconfont icon-shangshuangjiantou"></i>
                        </a>
                    </div>
                </div>
                <div class="balance-cards" :style="{ height: showBalance ? '140px' : '0px !important' }">
                    <div class="balance-card">
                        <div class="balance-change">{{ showYj ? userInfo.already_saved : '*****' }}</div>
                        <div class="balance-label">{{ $t('Deposited') }}</div>
                    </div>
                    <div class="balance-card">
                        <div class="balance-change">{{ showYj ? userInfo.all_lixi : '*****' }}</div>
                        <div class="balance-label">{{ $t('HoldingIncome') }}</div>
                    </div>
                    <div class="balance-card">
                        <div class="balance-change">{{ showYj ? userInfo.money : '*****' }}</div>
                        <div class="balance-label">{{ $t('AvailableBalance') }}</div>
                    </div>
                    <div class="balance-card">
                        <div class="balance-change">{{ showYj ? userInfo.total_investment_amount : '*****' }}</div>
                        <div class="balance-label">{{ $t('累计投资金额') }}</div>
                    </div>
                </div>
                <!-- 实时收益通知 -->
                <van-swipe class="notification-bars" :show-indicators="false" :autoplay="5000" indicator-color="white"
                    vertical>
                    <van-swipe-item v-for="(item, index) in data.announcement" :key="index">
                        <div class="notification-bar">
                            <span class="sound-icon">
                                <i class="iconfont icon-laba"></i>
                            </span>
                            <span class="user-info">{{ item.title }}</span>
                            <span style="color: #72918B;">{{ $t('Lucro') }}</span>
                            <span class="profit">+{{ item.amount }} USDT</span>
                        </div>
                    </van-swipe-item>
                </van-swipe>

            </div>
        </div>
        <!-- 底部标签栏 -->
        <div class="tab-btn-box">
            <div class="tab-item" :class="{ 'active': tabIndex === 0 }" @click="tabFun(0)">{{ $t('Strategic') }}</div>
            <div class="tab-item" :class="{ 'active': tabIndex === 1 }" @click="tabFun(1)">{{ $t('MyDeposits') }}</div>
        </div>

        <div class="investment-container" v-if="tabIndex === 0">
            <!-- 顶部标签栏 -->
            <div class="tab-bar">
                <button class="tab-item" :class="{ 'active': tabIndexs === 0 }" @click="tabFuns(null, 0)">{{ $t('All')
                    }}</button>
                <div v-for="(item, index) in tabsList" :key="index" class="tab-item new"
                    :class="{ 'active': tabIndexs === index + 1 }">
                    <button @click="tabFuns(item, index + 1)">
                        <!-- <span class="new-tag">NEW</span> -->
                        {{ item.name }}
                    </button>
                </div>
            </div>

            <!-- 投资卡片 -->
            <div class="investment-card" v-for="(item, index) in wealth_data.list" :key="index"
                @click="$router.push('/items/' + item.id)">
                <div class="investments" @click.stop v-if="item.level_status === 0"></div>
                <div class="card-avatar">
                    <img :src="item.img" :alt="item.title" />
                </div>
                <div class="card-content">
                    <div class="card-title">{{ item[lang]?item[lang]:item.title }}</div>
                    <div class="card-stats">
                        <div class="stat-item">
                            <span class="stat-value">{{ item.day_date_num_text }}</span>
                            <span class="stat-label">{{ $t('Term') }}</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-value">+{{ Number(item.interest_rate.total_gross_profit) }}% </span>
                            <span class="stat-label">{{ $t('TotalGrossProfit') }}</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-value">{{ $cut2 }}{{ item.min }}</span>
                            <span class="stat-label">{{ $t('Mininvest') }}</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-value">{{ $cut2 }}{{ item.max }}</span>
                            <span class="stat-label">{{ $t('Maxinvest') }}</span>
                        </div>
                    </div>
                    <div v-if="item.level_status !== 0">
                        <button class="subscribe-btn" @click.stop="subscribe(item)">{{ $t('Subscribe') }}</button>
                    </div>
                    <div v-else>
                        <button class="subscribe-btn" style="background: #B4B7B7;" @click.stop="subscribe">{{ item.level_text == 10 ?'SVIP':'Lv.'+item.level_text }} {{ $t('available') }}</button>
                    </div>
                    <div class="card-tip">{{ $t('djcks') }}</div>
                </div>
            </div>

        </div>
        <div class="investment-container" v-if="tabIndex === 1">
            <div class="err-box" v-if="list.length === 0">
                {{ $t('wzdckjl') }}
            </div>
            <div v-else class="uls-box">
                <div class="lis" v-for="(item, index) in list" :key="index">
                    <div class="t">
                        <span>{{ $t('金额') }}</span>
                        <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
                    </div>
                    <div class="t">
                        <span>{{ $t('订单编号') }}</span>
                        <span>{{ item.orderid }}</span>
                    </div>
                    <div class="t">
                        <span>{{ $t('状态') }}</span>
                        <span style="color: #CBCB41;" v-if="item.status === 0">{{ $t('PendingReview') }}</span>
                        <span style="color: #25C582;" v-if="item.status === 1">{{ $t('Completed') }}</span>
                        <span style="color: #D71804;" v-if="item.status === 2">{{ $t('Rejected') }}</span>
                        <span style="color: #CBCB41;" v-if="item.status === 3">{{ $t('PendingSubmission') }}</span>
                    </div>

                    <div class="t">
                        <span>{{ $t('订单创建时间') }}</span>
                        <span>{{ $t(item.time) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 150px;"></div>

    </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { setLocalStorage, getLocalStorage, clearLocalStorage, removeLocalStorage } from '../../utils/toLang.js'
import Api from "../../interface/index";
import footers from '@/components/bsFooter.vue'
import { lang_list, lang } from '@/locale/index'
import { Swipe, SwipeItem, Icon, Progress, Dialog, Field, Tab, Tabs, Empty, NoticeBar, Toast } from "vant";
import videos from "@/components/videos.vue";
let timeOut = null;
Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Tab).use(Tabs).use(Empty).use(NoticeBar);

export default {
    name: "Index",
    components: {
        videos,
        footers,
        VanSwipe: Swipe,
        VanSwipeItem: SwipeItem,
    },
    data() {
        return {
            showDHM:false,
            amtValue:'',
            duhText:'',
            orderShow: false,
            invite_code: '',
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            newPayPassword: '',
            confirmPayPassword: '',
            userInfo: null,
            lang_list: lang_list,
            kefu_link: '',
            telegram: '',
            whatsapp: '',
            tabIndex: 0,
            tabIndexs: 0,
            showChangePass: false,
            showChangePayPass:false,
            showInfoStatus: false,
            show: false,
            showBalance: false,
            showLangStatus: false,  //显示隐藏语言
            showYj: false,
            balances: {
                total: '0.0000',
                yesterdayChange: '+0.0000 - R$ 0.00',
                holdingEarnings: '+0.0000',
                available: '0.0000',
                totalEarnings: '+0.0000',
                deposited: '+0.0000'
            },
            // 通知数据
            notification: {
                user: 'Br****57',
                profit: '+21.68 USDT'
            },
            videoSrc: "",
            lang: this.$i18n.locale || "pt_pt",
            show_kefu: false,
            msg_show: true,
            loading: false,
            icon: [],
            data: {
                banner: []
            },
            show_img: false,
            show_tz: false,
            show_tc: false,
            tc_content: "",
            number: "",
            sku: [],
            tabsList: [],
            xwtabs: [],
            xwList: [],
            active: 0,
            xwActive: 0,
            wealth_data: [],
            listLength: 0,
            show_ts: false,
            wealth_number: "",
            wealth_sku: [],
            isSig: 1,
            logo: localStorage.getItem('logo') || '',
            stockList: [],
            notices: '',
            notice_num: 0,
            code: '',
            infos: null,
            list: []
        };
    },
    created() {
        this.$parent.footer("index");
        // Fetch('/user/notice').then((r) => {
        //     this.notice_num = r.data.ok_read_num;
        // });
        Fetch("/index/webconfig").then((r) => {
            // console.log(r,'renoticenoticenoticenoticenotices')
            this.notices = r.data.notice
            this.kefu_link = r.data.kefu_link
            this.telegram = r.data.telegram
            this.whatsapp = r.data.whatsapp
        });
        Fetch("/index/itemClass").then((r) => {
            this.tabsList = r.data
            // this.wealthStart(this.tabs[0].id);
        });
        Fetch("/user/info").then((r) => {
            this.userInfo = r.data;
            if (r.data.is_sign) {
                this.isSig = 2;
                return;
            }
            this.isSig = 1;
        });
        Fetch('/user/myTeam').then((r) => {
            this.invite_code = r.data.invite_code;
        });
        this.wealthStart(0)
    },
    mounted() {
        this.start();
        //代理标识设置
        if (this.$router.history.current.query.agent) {
            localStorage.setItem("agent", this.$router.history.current.query.agent);
        }
        timeOut = setInterval(() => {
            Fetch("/user/info", {}, {}, false).then((r) => {
                this.$set(this, 'userInfo', r.data)
            });
        }, 5000)
        var that = this;
        // document.body.addEventListener(
        //     "scroll",
        //     function () {
        //         if (!that.show_kefu) {
        //             return;
        //         }
        //         that.show_kefu = false;
        //     },
        //     false
        // );
        // document.addEventListener(
        //     "click",
        //     function (ev) {
        //         if (ev.target.className != "kefu_img") {
        //             that.show_kefu = false;
        //         }
        //     },
        //     false
        // );
        // var type = 0;
        // if (this.$router.history.current.query.type) {
        //   this.active = parseInt(this.$router.history.current.query.type);
        //   type = this.$router.history.current.query.type;
        // }
    },
    beforeDestroy() {
    // 先判断定时器是否存在，避免报错
        if (timeOut) {
            clearInterval(timeOut);
            timeOut = null; // 清空引用，防止内存泄漏
        }
    },
    methods: {

        showDhmFun() {
            this.showDHM = true
        },
        tabFun(type) {
            this.tabIndex = type
            if (this.tabIndex === 1) {
                Fetch('/user/recharge_list').then((r) => {
                    if (r.code == 1) {
                        // console.log(r.data, 'rrr')
                        this.list = r.data
                    } else {
                        this.$toast(r.msg)
                    }
                });
            }
        },
        tabFuns(items, indexs) {
            this.tabIndexs = indexs;
            if (indexs === 0) {
                this.wealthStart(indexs)
                return
            }
            this.wealthStart(items.id)
        },
        showBalanceFun() {
            console.log(this.showBalance)
            this.showBalance = !this.showBalance
        },
        formatNumbers(value) {
            value = value.split(',').join('')
            console.log(value, 'value')
            if (value >= 100000000) {
                return (value / 100000000).toFixed(1).replace(/\.0$/, '') + this.$t('亿');
            } else if (value >= 10000) {
                return (value / 10000).toFixed(1).replace(/\.0$/, '') + this.$t('万');
            } else {
                return value.toString();
            }
        },
        investFun(type) {
            let arr = this.wealth_data.invest_term
            let item = arr.find(x => x.value == type)
            let a = item.name_text ? item.name_text : ''
            return this.$t(a)
        },
        cateStart(type) {
            Fetch("/news/getCateNewsList", {
                cate_id: type,
            }).then((r) => {
                if (r.code == 1) {
                    this.xwList = r.data
                } else {
                    this.$toast(r.info)
                }
            });
        },
        formatNumber(num) {
            // 检查是否为数字
            if (isNaN(num)) return num;

            // 将数字转换为字符串，保留两位小数
            let str = Number(num).toFixed(2);

            // 分割整数部分和小数部分
            let parts = str.split('.');
            let integerPart = parts[0];
            let decimalPart = parts[1];

            // 如果整数部分长度小于4，直接返回原数字
            if (integerPart.length < 4) {
                if (decimalPart === '00') {
                    return integerPart;
                } else {
                    return integerPart + '.' + decimalPart;
                }
            }

            // 反转整数部分，以便从右向左处理
            let reversed = integerPart.split('').reverse().join('');

            // 每三位添加一个逗号
            let formatted = '';
            for (let i = 0; i < reversed.length; i++) {
                if (i > 0 && i % 3 === 0) {
                    formatted += ',';
                }
                formatted += reversed[i];
            }

            // 反转回来，并组合整数部分和小数部分
            formatted = formatted.split('').reverse().join('');

            // 如果小数部分是 '00'，则去掉小数部分
            if (decimalPart === '00') {
                return formatted;
            } else {
                return formatted + '.' + decimalPart;
            }
        },
        onVideoLoaded() {
            console.log("Video loaded");
        },
        onVideoEnded() {
            console.log("Video ended");
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push("/kefu");
            }
            this.show_kefu = !this.show_kefu;
        },
        amtInput(e) {
            console.log(e,'eee')
        },
        tcConfirm() {
            setLocalStorage('popNotice', true, 172800)
            this.show_tc = false
        },
        hideDown() {
            this.show_img = false;
            this.$store.commit("setShowAdvert", false);
        },
        start() {
            Fetch("/index/int").then((r) => {
                //打包web请注释掉版本更新这段代码
                //-----------------------------------------
                // if(window.plus){
                // let appVersion1 = plus.runtime.version;
                // let appVersion2 = r.data.version.app_version;
                // //版本号不同则更新APP
                // if(parseInt(appVersion1.split(".").join(""))<parseInt(appVersion2.split(".").join(""))){
                // 	this.$dialog.alert({
                // 	  title: 'APP更新',
                // 	  message: r.data.version.app_instructions,
                // 	}).then(() => {
                // 		let u = navigator.userAgent;
                // 		let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
                // 		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                // 		if (isAndroid) {
                // 		 // alert("我是安卓");
                // 			window.location.href = r.data.version.android_app_down_url;
                // 		}
                // 		if (isIOS) {
                // 		 // alert("我是苹果");
                // 		 window.location.href = r.data.version.ios_app_down_url;
                // 		}
                // 	});
                // }
                // }
                //-----------------------------------------
                this.data = r.data;
                // this.videoSrc = r.data.index_video_url;
                this.loading = true;
                // console.log(this.data, "this.data");
                const token = localStorage.getItem("token");
                let status = getLocalStorage('popNotice')
                if (r.data.popup.show == 1 && !status) {
                    this.tc_content = r.data.popup.content;
                    this.show_tc = true;
                }
            });
        },
        onChange(index) {
            let els = this.$refs.dian.querySelectorAll("div");
            for (let i = 0; i < els.length; i++) {
                els[i].className = "";
            }
            els[index].className = "selected";
        },
        buy(item) {
            if (this.isSig === 1) {
                this.$router.push("/contract");
                return;
            }
            this.sku = item;
            this.show_tz = true;
        },
        confirm() {
            // if (!this.number) {
            //   this.$toast(this.$t("item.inputAmount"));
            //   return false;
            // }
            Fetch("/index/item_apply", {
                id: this.sku.id,
                money: this.sku.fixed_investment_amount,
            }).then((r) => {
                if (r.code == 1) {
                    this.$toast(r.info);
                    setTimeout(() => {
                        this.$router.push("/order");
                    }, 500);
                    return;
                }
                this.$toast(r.msg);
            })
                .catch((err) => {
                    this.psd_val = "";
                });
        },
        wealthStart(type) {
            let data = {
                name: "",
                // index_type: type,
            }
            if (type !== 0) {
                data.cate_id = type
            }
            Fetch("/index/item_search", data).then((r) => {
                this.wealth_data = r.data;
                const sortedList = r.data.list.sort((a, b) => {
                    // 如果a的level_status是1，b不是 → a排前面（返回-1）
                    if (a.level_status === 1 && b.level_status !== 1) return -1;
                    // 如果b的status是1，a不是 → b排前面（返回1）
                    if (b.level_status === 1 && a.level_status !== 1) return 1;
                    // 其他情况（都为1 或 都不为1）→ 保持原有顺序（返回0）
                    return 0;
                });
                this.wealth_data.list = sortedList
                this.listLength = r.data.list.length;
            });
        },
        toUrl(type) {
            if (type == 1) {
                window.location.href = this.kefu_link
            }
            if (type == 2) {
                window.location.href = this.whatsapp
            }
            if (type == 3) {
                window.location.href = this.telegram
            }
        },
        cancelFun() {
            this.number = ''
        },
        handleSavePassword() {
            if (!this.newPassword) {
                this.$toast(this.$t('setpwd.newpasswordcannotbeempty'));
                return false;
            }

            if (this.newPassword !== this.confirmPassword) {
                this.$toast(this.$t('setpwd.inconsistent'));
                return false;
            }

            Fetch('/index/forgetpwd', {
                code: this.code,
                password: this.newPassword,
            }).then((r) => {
                if (r.code === 1) {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });
                    localStorage.removeItem('token');
                    setTimeout(() => {
                        this.$router.replace('/login')
                    }, 500)
                    return
                }
                this.$toast({
                    background: '#07c160',
                    message: r.msg
                });

            });
        },
        handleSavePayPassword() {
            if (!this.newPayPassword) {
                this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'));
                return false;
            }

            if (this.newPayPassword !== this.confirmPayPassword) {
                this.$toast(this.$t('setpaypwd.inconsistent'));
                return false;
            }

            Fetch('/user/resetpaypwd_code', {
                code: this.code,
                npassword: this.newPayPassword,
            }).then((r) => {
                if (r.code === 1) {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('setpwd.modifiedsuccessfully')
                    });
                    this.showChangePayPass = false
                    return
                }
                this.$toast({
                    background: '#07c160',
                    message: r.msg
                });
            });
        },
        wealthBuy(item) {
            if (this.isSig === 1) {
                this.$router.push("/contract");
                return;
            }
            this.wealth_sku = item;
            this.show_ts = true;
        },
        wealthConfirm() {
            if (!this.wealth_number) {
                this.$toast(this.$t("item.inputAmount"));
                return false;
            }
            Fetch("/index/item_apply", {
                id: this.wealth_sku.id,
                money: this.wealth_number,
            })
                .then((r) => {
                    this.$toast(r.msg);
                    if (r.code == 1) {
                        this.$toast(r.info);
                        setTimeout(() => {
                            this.$router.push("/order");
                        }, 500);
                        return;
                    }
                })
                .catch((err) => {
                    // this.psd_val = '';
                });
        },
        changeLang(lang, event) {
            Toast.loading({
                // mask: true,
                duration: 200
            })
            this.lang = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            window.location.reload()
        },
        showFun() {
            this.showInfoStatus = false;
            this.showChangePass = false;
            this.showChangePayPass = false;
            this.show = true;
        },
        handleCancel() {
            this.orderShow = false;
        },
        handleOk() {
            let lang = localStorage.getItem("lang")
            if (!lang) {
                lang = "pt_pt"
            }
            if (!this.amtValue) {
            	this.$toast(this.$t('qsrrgje'));
            	return false;
            }
            let data = {
                id: this.infos.id,
                money: this.amtValue,
                day: this.infos.day
                // money:this.data.project_type === 1?this.number:this.data.fixed_investment_amount
            }
            // if (this.sign_img != '') {
            // 	data.sign_img = this.sign_img
            // }
            Fetch("/index/item_apply", data).then(r => {
                if (r.code == 1) {
                    Toast(r.info ? r.info : r.msg)
                    Fetch("/user/info", {}, {}, false).then((r) => {
                        this.$set(this, 'userInfo', r.data)
                    });
                    setTimeout(() => {
                        this.infos = null
                        this.orderShow = false
                        this.showInfoStatus = false
                    }, 1500);
                } else {
                    Toast(r.msg)
                }
            }).catch(err => {
                this.number = '';
            })
        },
        subscribe(items) {
            this.infos = items
            this.amtValue = items.min
            this.orderShow = true
        },
        submitDhm() {
            Fetch("/redeem/claim", {code:this.duhText}).then(r => {
                if (r.code == 1) {
                    Toast(r.info ? r.info : r.msg)
                    setTimeout(() => {
                        this.showDHM = false
                    }, 1500);
                } else {
                    Toast(r.msg)
                }
            }).catch(err => {
                this.number = '';
            })
        },
        logout() {
            Dialog.confirm({
                message: this.$t('safe.signOut') + '?',
                confirmButtonText: this.$t('utils.confirm'),
                cancelButtonText: this.$t('utils.cancel')
            })
                .then(() => {
                    localStorage.removeItem('token');
                    this.$router.replace("/login");
                })
                .catch(() => {
                    // on cancel
                });

        }
    },
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
    padding: 15px 26px;
}

.home_wrap {
    width: 100%;
    min-height: 100vh;
    background-color: #0B1A26;
}

.red_top_bg {
    position: relative;
    position: fixed;
    top: 0;
    z-index: 10;
    background-color: #04006C;
    color: #101010;

    .logos {
        height: 34px;
        width: fit-content;

        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // left: 20px;
        img {
            width: auto;
            height: 100%;
            display: block;
        }
    }

    .menu,
    .not_logo {
        height: 26px;
        width: 26px;

        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }

    .not_logo {
        width: 26px;
        height: 26px;
        position: relative;

        .num {
            position: absolute;
            right: 0px;
            top: 0px;
            transform: translate(50%, 14%);
            background: red;
            color: #fff;
            padding: 2px 4px;
            font-size: 10px;
            border-radius: 10px;
        }
    }
}

.search_box {
    width: 80%;
    height: 29px;
    background-color: #f6f6f6;
    border-radius: 17px;
    margin: 8px 40px 0 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px 0 14px;

    .fdj {
        width: 16px;
        height: 16px;
        background: url(../images/item/fdj.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .search_inp {
        flex: 1;
        margin: 0 8px;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        height: 20px;
    }

    .clear_inp {
        width: 20px;
        height: 20px;
        background: url(../images/item/clear.png) no-repeat center center;
        background-size: 100% 100%;
    }
}

.swiper-container {
    width: 100%;
    height: 260px;
    background: #ffffff;

    .van-swipe-item {
        overflow: hidden;

        img {
            min-width: 100%;
            height: 100%;
        }
    }

    a {
        float: left;
        width: 100%;
        height: 100%;
        position: relative;

        &::after {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #00000030;
        }
    }
}

.work_box {
    background: #ffffff;
    padding: 17px 8px 4px 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
        width: 25%;
        text-align: center;
        margin-bottom: 10px;

        .item_img {
            width: 100%;
            border-radius: 5px;
            overflow: hidden;

            img {
                width: 44px;
                height: 44px;
            }
        }

        .item_title {
            width: 100%;
            line-height: 14px;
            font-size: 12px;
            color: #333333;
            text-align: center;
            transform: scale(0.85);
        }
    }
}

.work_box.query {
    .item {
        .item_img {
            border-radius: 5px;
            background: #f0f0f0;
        }

        .item_title {
            width: 100%;
            height: 14px;
            margin-left: 0;
            background: #f0f0f0;
        }
    }
}

.ads_box_1 {
    border-radius: 13px;
    margin-top: 10px;
    text-align: center;

    img {
        width: 95%;
    }
}

.ads_box {
    // background: rgba(255, 255, 255, 1);
    width: 97%;
    border-radius: 13px;
    margin: 10px auto 0 auto;
    display: flex;
    text-align: center;

    .ads_img {}

    img {
        width: 96%;
        border-radius: 5px;
    }
}

.items_1,
.items_2,
.items_3 {
    .items_tit {
        border-radius: 5px 5px 0 0;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        background: #ffffff;
        border-bottom: 1px solid #f7f7f7;
        padding: 0 14px;
        display: flex;
        justify-content: space-between;

        .tit_tip {
            display: contents;
            font-size: 12px;
            font-weight: normal;
            color: #b2b2b2;
            margin-left: 10px;
        }

        .tit_more {
            font-size: 12px;
            font-weight: normal;
            color: #b2b2b2;
        }
    }

    .item {
        background: #eee;
    }
}

.items_1 {
    .item {
        padding: 5px;
        box-shadow: 0px -10px 20px #00000010 inset;

        div {
            margin: 20px 0;
        }

        .item_tit {
            text-align: center;
            overflow: hidden;

            p {
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: bold;
                font-size: 16px;
            }
        }

        .item_rate {
            text-align: center;
            color: #000000;
            font-size: 22px;
            font-weight: bold;
        }

        .item_desc {
            display: flex;

            p {
                width: 50%;
                text-align: center;
            }
        }

        .item_btn {
            text-align: center;

            button {
                width: 60%;
                min-width: 60px;
                background: #000000;
                color: #ffffff;
                padding: 10px 0px;
                border-radius: 10px;
            }

            .item_btn_over {
                background: #999;
            }
        }
    }
}

.items_2 {
    .item {
        display: flex;
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #ececec;

        div {
            margin: 15px 0;
        }

        .item_rate {
            width: 20%;

            p {
                padding: 5px 0;
            }

            p:nth-child(1) {
                font-weight: bold;
                font-size: 14px;
                color: #000;
            }

            p:nth-child(2) {
                color: #999;
            }
        }

        .item_tit {
            width: 55%;

            p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 5px 0;
            }

            p:nth-child(1) {
                font-weight: bold;
            }

            p:nth-child(2) {
                color: #999;
            }
        }

        .item_btn {
            width: 25%;

            button {
                min-width: 60px;
                margin-top: 12px;
                color: #000;
                padding: 5px 5px;
                border-radius: 5px;
                border: 1px solid #000;
            }

            .item_btn_over {
                color: #999;
                border: 1px solid #999;
            }
        }
    }
}

.items_3 {
    padding-top: 5px;
    background: #fff;

    .item {
        width: 94%;
        margin: 8px auto 20px auto;
        background: #F4F4F4;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 2px 4px #eee;

        .item_div1 {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 10px;
            font-size: 15px;

            p:nth-child(1) {
                // width: 90%;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            p:nth-child(2) {
                color: #999;
            }
        }

        .item_img {
            width: 100%;
            height: fit-content;
            border-radius: 10px 10px 0px 0px;
            overflow: hidden;

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 10px 10px 0px 0px;
                border: 1px solid #999;
            }
        }

        .item_text {
            font-size: 14px;
            color: #333;
            padding: 0 10px;
            word-break: break-all;
        }

        .item_div2 {
            width: 100%;
            margin: 0px auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            font-size: 14px;
            padding: 0 10px;

            .divs {
                width: 32%;
                height: 85px;
                background: #fff;
                border-radius: 10px;
                overflow: hidden;
                box-shadow: 0px 4px 8px #eee;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 2px;
                flex-direction: column;

                p:nth-child(1) {
                    color: #A399AE;
                    margin: 8px auto;
                }
            }

            div {
                width: fit-content;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                .logos {
                    width: 22px;
                    height: 22px;
                    margin-right: 2px;
                }

                p {
                    padding: 0px;
                    text-align: left;
                    color: #A399AE;
                    text-align: center;
                    font-size: 13px;

                    span {
                        font-size: 16px;
                        color: #000;
                    }
                }

                .mt2 {
                    margin-top: 5px;
                }
            }

            .bians {
                width: 1px;
                padding: 0px;
                height: 40px;
                background: #333;
            }

            .item_rate {
                p:nth-child(1) {
                    font-weight: bold;
                    color: #A399AE;
                }
            }

            .item_day {
                p:nth-child(1) {
                    font-weight: bold;
                    color: #A399AE;
                }
            }

            .item_min {
                p:nth-child(1) {
                    font-weight: bold;
                    color: #A399AE;
                }
            }
        }

        .item_div3 {
            color: #999;
            padding: 0px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 12px;

            span {
                font-size: 13px;
            }

            .item_btn {
                width: fit-content;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                button {
                    min-width: 60px;
                    color: #000;
                    padding: 5px 12px;
                    border-radius: 5px;
                    background: #EBF302;
                    white-space: nowrap;
                }

                .item_btn_over {
                    color: #999;
                    border: 1px solid #999;
                }
            }
        }

        .item_div4 {
            width: 100%;
            padding: 0px 10px 20px 10px;
            margin-top: 10px;

            .flexs {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-bottom: 5px;
                color: #7F7E7E;
                font-size: 12px;
            }

            div:nth-child(1) {
                width: 100%;
            }

        }
    }
}

.popup {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
}

.h-title {
    font-size: 18px;
    padding: 18px 10px 6px 10px;
    font-weight: bold;
    font-size: 24px;
    font-weight: bold;
    color: transparent;
    background: linear-gradient(90deg, #0E726D, #FACB8F);
    -webkit-background-clip: text;
    background-clip: text;
    position: relative;
    display: inline-block;
}

.bg-video {
    width: 100%;
    height: 240px;
    overflow: hidden;

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.items {
    background: #038566;
    padding: 5%;

    .item_img {
        width: 100%;
        height: 198px;
        margin-bottom: 20px;

        img {
            width: 100%;
            display: block;
            height: 100%;
        }
    }

    .t1 {
        color: #29f5d5;
        font-size: 12px;
        margin-bottom: 10px;
    }

    .newsroom__title {
        font-family: "Beatrice Bold", Arial, Helvetica, sans-serif;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: normal;
        /* 依据语言规则在单词间换行 */
        white-space: normal;
        /* 合并多余空格，在换行符和容器边缘处换行 */
        font-size: 22px;
        color: #fff;
        display: block;
        font-weight: bold;
        line-height: 30px;
        padding-bottom: 20px;
    }
}

.wallet-container {
    max-width: 100%;
    height: fit-content;
    background: url('../../assets/images/bg.png') no-repeat right -40px;
    background-size: 100% 358px;
    background-blend-mode: overlay;
    position: relative;
    overflow: hidden;

    .wallet-containers {
        background: rgba(0, 0, 0, 0.35);
        width: 100%;
        height: fit-content;
    }

    /* 顶部导航 */
    .top-nav {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 16px 20px;
    }

    .nav-left {
        display: flex;
        gap: 20px;
    }

    .nav-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #86e8ff;
    }

    .nav-right {
        display: flex;
        gap: 16px;
        align-items: center;
    }

    .vip-badge {
        display: flex;
        align-items: center;
        gap: 8px;
        border-radius: 20px;
        color: #ffd700;

        .iconfont {
            font-size: 24px;
        }
    }

    .chat-icon {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #8EE3B9;
        border-radius: 50%;

        .iconfont {
            font-size: 28px;
            color: #8EE3B9;
        }
    }

    .more-icon {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 24px;
    }

    /* 数据卡片区域 */
    .balance-grid {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 50px 20px 8px 20px;
    }

    .balance-card {
        width: 40%;
        display: flex;
        flex-direction: column;
        padding-right: 5px;

    }

    .balance-cards {
        width: 100%;
        height: 0px;
        overflow: hidden;
        padding: 0 30px 8px 30px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        transition: 0.5s;

        .balance-card {
            width: 50%;
            display: flex;
            flex-direction: column;
            margin-top: 20px;
        }
    }

    .balance-change {
        color: #A0FCE4;
        font-weight: bold;
        font-size: 20px;
        white-space: nowrap;

        .yj {
            margin-left: 5px;

            .iconfont {
                font-size: 22px;
            }
        }
    }

    .balance-label {
        font-size: 13px;
        color: #e4e5e1;
        margin-top: 12px;
    }

    .total-balance-card {
        width: fit-content;
        align-items: center;
        margin-bottom: 10px;
    }

    .eye-icon {
        color: #86e8ff;
        margin-left: 8px;
    }

    .expand-icon {
        color: #B5EDCF;

        .iconfont {
            font-size: 20px;
        }
    }

    /* 实时收益通知条 */
    .notification-bars {
        width: 100%;
        height: 40px;
        overflow: hidden;
        background: #101f25;
        border-top: 1px solid rgba(134, 232, 255, 0.2);
        border-bottom: 1px solid rgba(134, 232, 255, 0.2);
    }

    .notification-bar {
        display: flex;
        align-items: center;
        height: 40px;
        gap: 5px;
        padding: 10px 20px;
        background: rgba(16, 31, 37, 1);
    }

    .sound-icon {
        color: #3EDAB7;
    }

    .user-info {
        color: #d0f0ff;
        font-size: 13px;
    }

    .profit {
        color: #4ade80;
        font-weight: 600;
        font-size: 13px;
    }

    /* 底部标签栏 */
    .tab-bar {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #0f1a2b;
        border-top: 2px solid #ffd700;
    }

    .tab-item {
        flex: 1;
        padding: 16px;
        text-align: center;
        color: #96A392;
        font-weight: 600;
        font-size: 18px;
        cursor: pointer;
    }

    .tab-item.active {
        color: #ffd700;
        border-bottom: 3px solid #ffd700;
    }
}

.footers {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 50px;

    .titles {
        color: #333;
        font-size: 28px;
        font-weight: bold;
        text-align: center;
    }

    .title2 {
        color: #333;
        font-size: 15px;
        margin: 15px auto;
    }

    .list2 {
        display: flex;
        width: 100%;
        margin: 0 auto 25px auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 15px;

        img {
            display: block;
            width: 22%;
            object-fit: contain;
            margin: 8px 0px;
        }
    }

    .list_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px 0px 35px 0px;

        a {
            position: relative;
            display: block;
            width: 36px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            margin: 0px 20px;
            border-radius: 6px;

            .iconfont {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            img {
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            span {
                font-size: 40px;
                color: #000;
            }
        }
    }

    .bottoms {
        width: 100%;
        height: fit-content;
        background: #04006C;
        padding: 20px 20px 0 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .lists {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 25px 20px 45px 20px;

            a {
                display: flex;
                width: 32px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                margin: 0px 10px;
                border-radius: 6px;

                span {
                    font-size: 20px;
                    color: #fff;
                }
            }
        }

        .logo {
            width: 220px;
            height: fit-content;
            padding-bottom: 30px;

            img {
                display: block;
                width: 100%;
                height: auto;
            }
        }
    }

    .texts {
        width: 100%;
        height: fit-content;
        padding: 0 15px 30px 15px;
        background: #04006C;
        color: #fff;
        font-size: 13px;
        line-height: 18px;
    }

    .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 30px;
        background: #04006C;

        p {
            width: 100%;
            font-size: 10px;
            margin: 5px auto;
            text-align: center;
            color: #fff;
        }
    }
}

.tab-btn-box {
    width: 100%;
    height: 44px;
    margin: 10px auto;
    background: #0B2C25;
    display: flex;
    align-items: center;
    justify-content: center;

    .tab-item {
        flex: 1;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #96A392;
    }

    .active {
        color: #FFD64D;
        border-bottom: 2px solid #FFD64D;
    }
}

::v-deep .van-progress__pivot {
    display: none;
}

.main-box {
    width: 100vw;
    max-width: 520px;
    height: 100dvh;
    position: relative;
    background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);

    .hr {
        width: 100%;
        height: 1px;
    }

    .pop_pass {
        width: 100%;
        height: 100%;
        position: relative;
        background: rgba(0, 0, 0, 0.7);
        background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 30;

        .pop-pass-box {
            width: 98%;
            height: fit-content;
            padding: 30px 20px 30px 20px;
            border-radius: 20px;
            border: 1px solid #3D615B;
            background: rgba(9, 39, 32, 1);
            background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);

            .hrs {
                width: 60px;
                height: 4px;
                margin: 0 auto 10px auto;
                border-radius: 10px;
                background: #687A6F;
            }
        }

        .title-box {
            width: 100%;
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px solid #3D615B;

            h2 {
                color: #fff;
                margin-left: 10px;
            }

            .btn,
            .back {
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #2D4B44;
                border-radius: 12px;
                padding: 8px 9px;
                color: #fff;
                margin-left: auto;
                background: none;

                .iconfont {
                    font-size: 18px;
                }
            }

            .btn {
                transform: translateY(-20px);
            }

            .back {
                margin-left: 0px;
            }
        }

        /* 表单组 */
        .form-group {
            margin-bottom: 24px;
        }

        .form-label {
            display: block;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 12px;
            color: rgba(255, 255, 255, 0.9);
        }

        .form-input {
            width: 100%;
            height: 56px;
            padding: 0 20px;
            background: rgba(255, 255, 255, 0.08);
            border: 1px solid rgba(255, 255, 255, 0.15);
            border-radius: 16px;
            color: #fff;
            font-size: 16px;
            outline: none;
            transition: all 0.2s ease;
        }

        .form-input::placeholder {
            color: rgba(255, 255, 255, 0.3);
        }

        .form-input:focus {
            border-color: #34d399;
            background: rgba(255, 255, 255, 0.12);
        }

        /* 保存按钮 */
        .save-btn {
            width: 100%;
            height: 52px;
            background: #34d399;
            border: none;
            border-radius: 16px;
            color: #0f2b23;
            font-size: 18px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .save-btn:hover {
            background: #22c58a;
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(52, 211, 153, 0.3);
        }

        .save-btn:active {
            transform: translateY(0);
        }
    }

    .box {
        width: 100%;
        height: 100%;
        position: relative;
        background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            h2 {
                color: #fff;
            }

            .btn {
                border: 1px solid #2D4B44;
                border-radius: 15px;
                padding: 6px 9px;
                color: #fff;

                .iconfont {
                    font-size: 18px;
                }
            }
        }

        .uls {
            width: 100%;
            height: 100%;
            margin-top: 20px;
            display: flex;
            flex-direction: column;

            .t {
                color: #ffffffa6;
                font-size: 11px;
                text-transform: uppercase;
            }

            .hr {
                margin-top: auto;
                width: 100%;
                height: 2px;
                background: #476052;
                margin-top: auto;
            }

            .t-box {
                width: 100%;
                height: fit-content;
                margin-top: 10px;
                padding: 12px;
                border-radius: 15px;
                border: 1.5px solid #518b80;
                background: #245547;
                background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, rgba(43, 68, 47, 1) 100%);
                display: flex;
                align-items: center;
                position: relative;
                cursor: pointer;

                .li {
                    width: 100%;
                    height: fit-content;
                    display: flex;
                    border: 1px solid #4e8886;
                    border-radius: 15px;
                    padding: 12px;
                    align-items: center;
                    background: rgba(32, 67, 62, 0.5);

                    .logos {
                        width: fit-content;
                        height: 18px;
                        border: 1px solid #4D6D69;
                        border-radius: 10px;
                        margin-right: 10px;

                        img {
                            display: block;
                            width: auto;
                            height: 100%;
                        }
                    }

                    .t-text {
                        font-size: 14px;
                        font-weight: bold;
                        color: #ffffff;
                    }

                    .icon {
                        .iconfont {
                            font-size: 22px;
                        }
                    }
                }

                .boxs {
                    position: relative;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 60px;
                    z-index: 99;
                    border-radius: 20px;
                    background: #245547;
                    background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, #051A15 100%);
                    overflow: hidden;
                    overflow-y: scroll;
                    padding: 12px;

                    .lis {
                        width: 100%;
                        display: flex;
                        background: rgba(18, 46, 41, 0.3);
                        border-radius: 10px;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        padding: 15px;
                        border: 1px solid #4e8886;

                        img {
                            display: block;
                            width: auto;
                            height: 16px;
                            margin-right: 10px;
                        }

                        span {
                            color: #fff;
                            font-size: 14px
                        }
                    }
                }

                .icon {
                    margin-left: auto;
                    transition: 0.3s;

                    .iconfont {
                        font-size: 14px;
                        color: #758678;
                    }
                }

                .logo {
                    padding: 7px;
                    border-radius: 10px;
                    margin-right: 10px;
                    border: 1px solid #4A726A;

                    .iconfont {
                        color: #ffffff;
                        font-size: 20px;
                    }
                }

                .t-boxs {
                    color: #ffffff;

                    .t1 {
                        font-size: 15px;
                    }

                    .t2 {
                        font-size: 12px;
                        margin-top: 8px;
                    }
                }

                .boxs {
                    width: 325px;
                    height: fit-content;
                    max-height: 256px;
                    overflow: hidden;

                    .active-li {
                        background: rgba(43, 61, 34, 0.8) !important;
                    }
                }
            }
        }
    }
}

.xz {
    transform: rotate(180deg) !important;
}

/* 页面容器 */
.personal-data-page {
    padding: 15px;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    position: relative;
    background: rgb(23, 57, 42);
    background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 30;

    /* 顶部导航栏 */
    .title-box {
        width: 100%;
        display: flex;
        align-items: center;
        padding-bottom: 20px;

        h2 {
            color: #fff;
            margin-left: 10px;
        }

        .btn,
        .back {
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #375852;
            border-radius: 12px;
            padding: 8px 9px;
            color: #fff;
            margin-left: auto;
            background: none;
            cursor: pointer;

            .iconfont {
                font-size: 18px;
            }
        }

        .back {
            margin-left: 0px;
        }
    }

    /* 信息卡片 */
    .info-card {
        width: 100%;
        background: #174439;
        background: linear-gradient(214deg, rgba(23, 68, 57, 1) 0%, rgba(22, 60, 51, 1) 55%, rgba(43, 73, 54, 1) 100%);
        border-radius: 16px;
        padding: 15px;
        border: 1px solid #375852;
        margin-bottom: auto;
    }

    .card-header {
        margin-bottom: 20px;
    }

    .card-title {
        font-size: 22px;
        color: #ffffff;
        font-weight: 700;
        margin-bottom: 8px;
    }

    .card-subtitle {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
    }

    .divider {
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin: 20px 0;
    }

    /* 信息行 */
    .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        font-size: 14px;
    }

    .info-label {
        color: rgba(255, 255, 255, 0.7);
    }

    .info-value {
        font-weight: 600;
        color: #fff;
    }

    .info-value.empty {
        color: rgba(255, 255, 255, 0.4);
    }

    .hr {
        margin-top: auto;
        width: 100%;
        height: 2px;
        background: #476052;
        margin-top: auto;
    }

    .t-box {
        width: 100%;
        height: fit-content;
        margin-top: 10px;
        padding: 12px;
        border-radius: 15px;
        border: 1.5px solid #518b80;
        background: #245547;
        background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, rgba(43, 68, 47, 1) 100%);
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
    }
}

/* 弹窗容器 */
.deposit-modal {
    width: 100%;
    background: linear-gradient(145deg, #0b3024, #08241b);
    border-radius: 20px;
    padding: 10px 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    color: #fff;
    border: 1px solid rgba(0, 180, 120, 0.2);

    .hrs {
        width: 60px;
        height: 4px;
        margin: 0 auto 15px auto;
        border-radius: 10px;
        background: #687A6F;
    }

    /* 顶部标题栏 */
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
    }

    .user-info {
        flex: 1;
    }

    .user-name {
        font-size: 14px;
        font-weight: 700;
        margin-bottom: 4px;
    }

    .profit-info {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-top: 10px;
    }

    .deposit-btn {
        border: 1px solid #2D4D46;
        border-radius: 8px;
        color: #D1FAE5;
        font-size: 12px;
        font-weight: 600;
        padding: 8px 12px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .deposit-btn:hover {
        background: #009e6a;
    }

    /* 信息卡片组 */
    .info-card {
        background: #143933;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 12px;
        border: 1px solid #365652;
    }

    .card-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        margin-bottom: 8px;
    }

    .card-value {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }

    .lis {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    /* 投资金额行 */
    .investment-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #143933;
        border-radius: 15px;
        padding: 16px;
        margin-bottom: 12px;
        border: 1px solid #365652;
    }

    .investment-label {
        font-size: 12px;
        color: #C6EFDA;
    }

    .investment-right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 0px;
    }

    .investment-value {
        width: 80%;
        font-size: 16px;
        font-weight: 600;
        input {
            width: 100%;
        }
    }

    .rules-link {
        font-size: 12px;
        color: #C6EFDA;
        cursor: pointer;
    }

    .rules-link:hover {
        color: #00b478;
    }

    /* 折扣/手续费行 */
    .fee-row {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        padding: 6px 0px;
    }

    .fee-label {
        color: #CCF5E0;
    }

    .fee-value {
        color: rgba(255, 255, 255, 0.8);
    }

    /* 总计行 */
    .total-row {
        background: #143832;
        border-radius: 12px;
        padding: 16px;
        margin: 12px 0 24px;
        border: 1px solid #35534F;
    }

    .total-inner {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // border-top: 1px solid #35534F;
        // margin-top: 10px;
    }

    .total-label {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
    }

    .total-value {
        font-size: 14px;
        font-weight: 700;
        color: #fff;
    }

    .cut {
        color: #D1FAE5;
    }

    /* 操作按钮 */
    .action-buttons {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .ok-btn {
        height: 46px;
        background: linear-gradient(90deg, #00d186, #00b478);
        border: none;
        border-radius: 12px;
        color: #222;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .ok-btn:hover {
        background: linear-gradient(90deg, #00bb78, #009e6a);
    }

    .cancel-btn {
        height: 46px;
        background: transparent;
        border: none;
        border-radius: 12px;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .cancel-btn:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.05);
    }
}

.err-box {
    width: 100%;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #73928C;
    font-size: 14px;
}

::v-deep .van-popup {
    background: none;
}

.uls-box {
    width: 100%;
    height: fit-content;

    .lis {
        border: 1px solid #265245;
        background: #153932;
        padding: 10px;
        border-radius: 12px;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;

        .t {
            width: 100%;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;

            span {
                color: #E6F7EF;
            }

            span:last-child {
                color: #eee;
            }
        }

        .t:last-child {
            margin-bottom: 0px;
        }
    }
}
</style>
